import React, { useState } from "react";
import { Form, Row, Col, Modal, Button, Image } from "react-bootstrap";
import { NewInputText } from "../../../../../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import { SliderReusableComponent } from "../../../../../../../reusableComponents/sliderReusableComponent/SliderReusableComponent";
import { BackLogoIconButton } from "../../../../../../../reusableComponents/smallReusableComponent/LoginTopLogoAndText";
import {
  getCountries,
  getCountryCallingCode,
} from "react-phone-number-input/input";
import en from "react-phone-number-input/locale/en.json";
import { TopTextReusableComponent } from "../../../../../../reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import { ReusableOnboardingButton } from "../../../../../../reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import { AddButtonIconComponent } from "../../../../../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";

export const FastFoodUploadMenu = (props) => {
  //state
  const [countryCode, setCountryCode] = useState("+91");
  const [nextStepModal, setNextStepModal] = useState(false);
  const [file, setFile] = useState(null);

  const uploadImage = (e) => {
    setFile(URL.createObjectURL(e.target.files[0]));
  };
  const handleCloseZNextStepModal = () => {
    setNextStepModal(false);
  };
  const handleShowZNextStepModal = () => {
    setNextStepModal(true);
  };
  const handleChangeCode = (e) => {
    const { value, maxLength } = e.target;
    const number = value.slice(0, maxLength);
    setCountryCode(number);
  };
  const onWithOutApiCall = (e) => {
    props.history.push({
      pathname: "/fastfood/menusetup",
    });
  };
  const handleShowZPrevStepModal = (e) => {
    props.history.push({
      pathname: props.history.location.pathname.includes("admin")
        ? "/admin-fastfood/menusetup"
        : "/fastfood/menusetup",
    });
  };
  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div
            id="onboarding-scrollbar"
            className="col-lg-6 col-xl-6 onboarding_process_screen_left"
          >
            <div className="col-12">
              <BackLogoIconButton
                displayBackText={true}
                displayArrow={true}
                workWithLinkORClick={true}
                backButtonClicked={
                  props.history.location.pathname.includes("admin")
                    ? "/admin-fastfood/menusetup"
                    : "/fastfood/menusetup"
                }
              />
            </div>
            <div className="onboarding_process_screen-left-mapinside">
              <div className="mb-5">
                <TopTextReusableComponent
                  headingText="Menu Upload"
                  headingParagraph="You can upload your menu & leave rest to us"
                />
              </div>
              <div className="f16-700 mb-1">
                Upload Your Menu and Let us take care of the rest
              </div>
              <Form>
                <React.Fragment>
                  <div className="row align-items-center my-3">
                    <div className="col-7">
                      <NewInputText
                        extraClass="mb-0 w-100"
                        labelText="Main Menu"
                      />
                    </div>
                    <div className="col-5">
                      <AddButtonIconComponent
                        buttonText="Add Another"
                        fontIcon="fa fa-plus"
                        colorCss="blue"
                      />
                    </div>
                  </div>
                  <Form.Label className="f14-500 mt-2 mb-1">
                    Upload Images
                  </Form.Label>
                  <div className="d-flex flex-wrap">
                    <div className="enUploadBox">
                      <Image
                        src={require("../../../../../../../../assets/images/UserManagement/uploadImg.svg")}
                        alt="uploadImg"
                        title="uploadImg"
                        fluid
                      />
                      <input
                        type="file"
                        accept=".png, .jpg, .jpeg"
                        onChange={uploadImage}
                      />
                    </div>
                    {file && (
                      <div className="enIconUploaded">
                        <button
                          type="button"
                          className="enCloseButton"
                          onClick={() => setFile(null)}
                        >
                          <Image
                            src={require("../../../../../../../../assets/images/UserManagement/en_close.svg")}
                            alt="uploadImg"
                            title="uploadImg"
                            fluid
                          />
                        </button>
                        <Image
                          src={file}
                          alt="icon"
                          title="icon"
                          className=""
                          fluid
                        />
                      </div>
                    )}
                  </div>
                  <div className="f12-400 opacity5 pb-3">
                    * please upload in the provided below formats
                  </div>
                  <div className="d-flex align-items-center pb-3">
                    <Image
                      width="22px"
                      alt="Image"
                      className="mr-3"
                      src={require("../../../../../../../../assets/images/UserManagement/file_img.svg")}
                    />
                    <Image
                      width="22px"
                      alt="Image"
                      className="mr-3"
                      src={require("../../../../../../../../assets/images/UserManagement/file_pdf.svg")}
                    />
                    <Image
                      width="22px"
                      alt="Image"
                      className="mr-3"
                      src={require("../../../../../../../../assets/images/UserManagement/file_doc.svg")}
                    />
                    <Image
                      width="22px"
                      alt="Image"
                      className="mr-3"
                      src={require("../../../../../../../../assets/images/UserManagement/file_xls.svg")}
                    />
                  </div>
                </React.Fragment>
                <React.Fragment>
                  <div className="row align-items-center my-3">
                    <div className="col-7">
                      <NewInputText
                        extraClass="mb-0 w-100"
                        labelText="Main Menu"
                      />
                    </div>
                    <div className="col-5">
                      <AddButtonIconComponent
                        buttonText="Delete"
                        fontIcon="fa fa-trash-o"
                        colorCss="delete"
                      />
                    </div>
                  </div>
                  <Form.Label className="f14-500 mt-2 mb-1">
                    Upload Images
                  </Form.Label>
                  <div className="d-flex flex-wrap">
                    <div className="enUploadBox">
                      <Image
                        src={require("../../../../../../../../assets/images/UserManagement/uploadImg.svg")}
                        alt="uploadImg"
                        title="uploadImg"
                        fluid
                      />
                      <input
                        type="file"
                        accept=".png, .jpg, .jpeg"
                        onChange={uploadImage}
                      />
                    </div>
                    {file && (
                      <div className="enIconUploaded">
                        <button
                          type="button"
                          className="enCloseButton"
                          onClick={() => setFile(null)}
                        >
                          <Image
                            src={require("../../../../../../../../assets/images/UserManagement/en_close.svg")}
                            alt="uploadImg"
                            title="uploadImg"
                            fluid
                          />
                        </button>
                        <Image
                          src={file}
                          alt="icon"
                          title="icon"
                          className=""
                          fluid
                        />
                      </div>
                    )}
                  </div>
                  <div className="f12-400 opacity5 pb-3">
                    * please upload in the provided below formats
                  </div>
                  <div className="d-flex align-items-center pb-3">
                    <Image
                      width="22px"
                      alt="Image"
                      className="mr-3"
                      src={require("../../../../../../../../assets/images/UserManagement/file_img.svg")}
                    />
                    <Image
                      width="22px"
                      alt="Image"
                      className="mr-3"
                      src={require("../../../../../../../../assets/images/UserManagement/file_pdf.svg")}
                    />
                    <Image
                      width="22px"
                      alt="Image"
                      className="mr-3"
                      src={require("../../../../../../../../assets/images/UserManagement/file_doc.svg")}
                    />
                    <Image
                      width="22px"
                      alt="Image"
                      className="mr-3"
                      src={require("../../../../../../../../assets/images/UserManagement/file_xls.svg")}
                    />
                  </div>
                </React.Fragment>
                <div className="text-dark f12-700 py-3">
                  Share your contact details with us and we will reach to you
                  for Menu Setup
                </div>
                <Row>
                  <Col md={9}>
                    <NewInputText
                      labelText="Email Address"
                      extraClass="mb-3 w-100"
                    />
                  </Col>
                  <Col md={9}>
                    <div className="row mb-4">
                      <div className="col-5 col-xl-4">
                        <Form.Group
                          className="reusableInputComponent-main mb-0"
                          controlId={"country_code"}
                        >
                          <div className="input-phone-country-code-reusable w-100">
                            <select
                              className="w-100"
                              //   name="country_code"
                              value={countryCode}
                              onChange={handleChangeCode}
                            >
                              <option value={countryCode}>{countryCode}</option>
                              {getCountries().map((country) => (
                                <option
                                  key={country}
                                  value={"+" + getCountryCallingCode(country)}
                                >
                                  {en[country]} (+
                                  {getCountryCallingCode(country)})
                                </option>
                              ))}
                            </select>
                          </div>
                        </Form.Group>
                      </div>
                      <div className="col-7 col-xl-8 pl-0">
                        <NewInputText
                          extraClass="mb-3 w-100"
                          inputType="number"
                          maxLength="10"
                          labelText="Phone Number*"
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
                <div className="onboarding-map-setup-screen-autodetect-button mt-5">
                  <ReusableOnboardingButton
                    buttonTitle="Next Button"
                    buttonClass="btn-lg btn btn-outline-secondary btn-lg"
                    buttonText="Cancel"
                    buttonType="button"
                    onClick={handleShowZPrevStepModal}
                  />
                  <ReusableOnboardingButton
                    buttonTitle="Next Button"
                    buttonClass="btn-lg btn btn-danger btn-lg ml-3 "
                    buttonText="Submit"
                    buttonType="button"
                    onClick={handleShowZNextStepModal}
                  />
                </div>
              </Form>
            </div>
          </div>
          <div className="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 loginsignup-rightside">
            <SliderReusableComponent
              // displayBarButton={false}
              displayHamburger={true}
              paragraphOne="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
              paragraphTwo="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
              paragraphThree="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
              bottomImage={require("../../../../../../../../assets/images/illustratorImage/Amealio_Illustrations-01.svg")}
            />
          </div>
        </div>
      </div>
      <Modal
        show={nextStepModal}
        onHide={handleCloseZNextStepModal}
        centered
        className="xl-width-750"
        keyboard={false}
        backdrop={"static"}
      >
        <Modal.Header className="px-4 border-0" closeButton>
          <div className="w-100">
            <Modal.Title className="f16-700 pb-2">Success</Modal.Title>
            <p className="f11-400">You have successfully set up your menu!</p>
            <p className="f11-400 text-gray my-3">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod temporLorem ipsum dolor sit amet, consectetur adipiscin
            </p>
            <Image
              src={require("../../../../../../../../assets/images/illustratorImage/success.svg")}
              alt="Success"
              title="Success"
              fluid
              width="240px"
            />
          </div>
        </Modal.Header>
        <Modal.Body className="px-4">
          <Button
            variant="danger"
            className="btn150px btn-lg px-5"
            onClick={onWithOutApiCall}
          >
            Okay
          </Button>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};
